import React from "react";
import PolicyUpdates from "./PolicyUpdates";

export default function PolicyUpdatesAndEvents({alert}) {
  return (
    <div className="page-content">
      <PolicyUpdates alert={alert} />
    </div>
  );
}
